import { render } from "./phone-top-nav.vue?vue&type=template&id=3e79ae83&scoped=true"
import script from "./phone-top-nav.vue?vue&type=script&lang=js"
export * from "./phone-top-nav.vue?vue&type=script&lang=js"

import "./phone-top-nav.vue?vue&type=style&index=0&id=3e79ae83&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e79ae83"]])

export default __exports__